import { useCallback, useState } from 'react';

import { CustomChartExistingInfo } from '@/types/schema';

export const useChartCrud = () => {
  const [chartCrudState, setChartCrudState] = useState({
    isOpen: false,
    chartData: undefined as CustomChartExistingInfo | undefined,
  });

  const openNewChart = useCallback(() => {
    setChartCrudState({ isOpen: true, chartData: undefined });
  }, []);

  const openExistingChart = useCallback(
    (chartData: CustomChartExistingInfo) => {
      setChartCrudState({ isOpen: true, chartData });
    },
    []
  );

  const closeChartCrudPane = useCallback(() => {
    setChartCrudState({ isOpen: false, chartData: undefined });
  }, []);

  return {
    isOpen: chartCrudState.isOpen,
    chartData: chartCrudState.chartData,
    openNewChart,
    openExistingChart,
    closeChartCrudPane,
  };
};
